











































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { SpecOutListModule } from '@/store/modules/specOutList';
import Alert from '@/components/Shared/Alert.vue'
import SpecOutDto from '@/models/SpecOuts/SpecOutDto'
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import SpecOutCreate from '@/components/SpecOuts/SpecOutCreate.vue';
import SpecOutStatus from '@/components/SpecOuts/Display/SpecOutStatus.vue';
import SpecOutListSearchCriteria from '@/components/SpecOuts/SpecOutListSearchCriteria.vue';


@Component({
	name: 'AgencySpecOuts',
  	components: { Alert, SpecOutCreate, SpecOutStatus, SpecOutListSearchCriteria }
})
export default class extends GiganautVue {

  async beforeMount() {
    await SpecOutListModule.searchSpecOuts();
  }

  async navigateToSpecOut(specOutId: string) {
    this.$router.push({ name: PageNames.AgencySpecOutDetails, params: { specoutid: specOutId } });
  }

  get loading() {
		return SpecOutListModule.loading;
   }

  private search = '';

  get specOuts() {
    return SpecOutListModule.specOuts;
  }

   private headers = [
    { text: 'Worker', value: 'worker.person.firstName' },
    { text: 'Owner', value: 'owner.person.firstName' },
    { text: 'Branch', value: 'branch.brandName' },
    { text: 'Status', value: 'status'},
    { text: 'Sent At', value: 'sentAt'},
    { text: 'Actions' },
  ]
}
